import {Button,CircularProgress, Divider} from '@material-ui/core';
import { Grid, TextField, Typography} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import {useDispatch} from 'react-redux';
import * as userActions from '../actions/authenticationActions';
import {useHistory} from 'react-router-dom';
import {LOGIN_PAGE_TEXTS} from '../utility';
import * as briefActions from '../actions/briefActions';


const UiInput = makeStyles({
  root : {
    "& .MuiInputBase-input": {
      borderRaduis: '4px',
      border: 'none',
      boxShadow: '0px 1px 6px #7784945e',
      padding: '5px 10px',
      margin: 0
  },
  "& .MuiInputBase-input:focus": {
      boxShadow:'none',
      outline:'none'
  },
  }
});


function LoginFormLegacy(props){
    const uiInputClass = UiInput().root;
    const dispatch = useDispatch();
    const history = useHistory();
    const [sEmail, setEmail] = React.useState();
    const [sPassword, setPassword] = React.useState();
    const [loginInProgress, setLoginInProgress] = React.useState(false);

    const loginDispatch = () => {
      if(sEmail && sPassword){
        setLoginInProgress(true);
        dispatch(userActions.loginUser(sEmail,sPassword,props.openSnackbar,setLoginInProgress, () => {
          window.AP.tanalytics.identify({
            email: sEmail,
            legacy: true
          });
          window.AP.tanalytics.track('User Login (Legacy)');
          dispatch(briefActions.getBriefs());
          history.push({
            pathname: '/dashboard_legacy'
          })
        }));
      }
    }

    const loadBriefView = () => {
      history.push({
        pathname: '/load_brief',
        state: { openSnackbar: props.openSnackbar }
      });
    }

    const loadLoginAdthriveView = () => {
      history.push({
        pathname: '/login_adthrive',
        state: { openSnackbar: props.openSnackbar }
      });
    }
    
    return(
        <Grid container xs="12" md="12" direction="column" alignItems="center" justify="center" spacing={1} style={{position:'absolute',top:'8rem'}}>
            <Grid item>
            <Typography variant="h6" color="primary" style={{fontWeight:'bold',textAlign:'center'}}>{LOGIN_PAGE_TEXTS.SIGN_IN_TEXT}</Typography>
            <p>
              (for non-AdThrive users)
            </p>
            </Grid>
            <Grid item>
                <TextField
                className={uiInputClass}
                id="standard-full-width"
                label={LOGIN_PAGE_TEXTS.EMAIL_TEXTFIELD_LABAL_TEXT}
                style={{ margin: 8 }}
                placeholder={LOGIN_PAGE_TEXTS.EMAIL_TEXTFIELD_PLACEMENT_TEXT}
                type="email"
                fullWidth
                value={sEmail}
                onChange={(event) => {setEmail(event.target.value)}}
                margin="normal"
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </Grid>
          <Grid item>
            <TextField
                className={uiInputClass}
                id="standard-full-width"
                label={LOGIN_PAGE_TEXTS.PASSWORD_TEXTFIELD_LABAL_TEXT}
                type="password"
                value={sPassword}
                onChange={(event) => {setPassword(event.target.value)}}
                style={{ margin: 8 }}
                placeholder={LOGIN_PAGE_TEXTS.PASSWORD_TEXTFIELD_PLACEMENT_TEXT}
                fullWidth
                margin="normal"
                InputLabelProps={{
                    shrink: true,
                }}
                />
          </Grid>
          <Grid item alignItems="center" justify="center" style={{textAlign:'center'}}>
            <Button variant="contained" color="primary" size="small" disabled={loginInProgress} onClick={loginDispatch}>
             {(!loginInProgress) ? LOGIN_PAGE_TEXTS.SIGN_IN_TEXT : <CircularProgress size={24} />}   
            </Button>
          </Grid>
          <Grid item align="center">
            <Divider/>
            <Grid item>
              <a variant="subtitle2" onClick={loadLoginAdthriveView} className="link" style={{textDecoration:'underline',cursor:'pointer'}}>Log in (AdThrive)</a>
            </Grid>
            <Grid item style={{marginTop: '6px'}}>
              <a variant="subtitle2" onClick={loadBriefView} className="link" style={{textDecoration:'underline',cursor:'pointer'}}>{LOGIN_PAGE_TEXTS.LOAD_BRIEF_BUTTON_TEXT}</a>
            </Grid>
          </Grid>
          <Grid item>
            <div style={{"margin":"20px","backgroundColor":"white","padding":"10px","borderRadius":"4px","boxShadow":"0px 1px 6px #7784945e"}}>
              <span style={{fontWeight:'bold'}}>Are you an AdThrive Publisher?</span>
              <p style={{marginTop: '10px', marginBottom: '0'}}>
                Watch <a href="https://vimeo.com/594907722" target="_blank">this short video</a> to learn how to use this plugin with your AdThrive account.
              </p>
            </div>
          </Grid>
        </Grid>
    );

}

export default LoginFormLegacy;